import { getLevelGIA as n } from "./index20.js";
import { getLevelNIA as i } from "./index25.js";
const m = (e, t) => {
  const o = n(e, t), r = i(e, t);
  return o - r;
};
export {
  m as getLevelNonResidentialArea
};
//# sourceMappingURL=index26.js.map
